export const initialState = {
    items: [],
    loading: false,
    page: 0,
    total_pages: 0,
    total: 0
};


export function paginatedResultReducer(state=initialState, ACTION, action) {
    switch (action.type) {
        case ACTION.REQUEST:
            //not first page - results will be appended
            if (action.meta.page) {
                return {
                    ...state,
                    loading: true
                };
            //first page - results will be replaced
            } else {
                return {
                    ...initialState,
                    loading: true
                }
            }
        case ACTION.SUCCESS:
            return {
                ...state,
                //items: action.payload.page ? [...state.items, ...action.payload.result] : action.payload.result,
                items: action.payload.result,
                page: action.payload.page,
                total_pages: action.payload.total_pages,
                total: action.payload.total,
                loading: false
            };
        case ACTION.FAILURE:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }

}



// WEBPACK FOOTER //
// ./src/js/reducers/common/paginated_results.js